import { resetCrudSelection, useEditingStateWithCtx } from '@/atoms'
import { preview } from '@/components/form/preview'
import { useReadOnlyTooltipData } from '@/components/smartUtils/plan/ReadOnlyTooltip'
import { Password } from '@mui/icons-material'
import { Delete, Edit } from '@workwave-tidal/core/icons'
import { useCallback } from 'react'
import { useChangePasswordModal } from '../../../modals/ChangePassword'
import { useDeleteDriverModal } from '../../../modals/DeleteDriver'
import { useTexts } from '../hooks/useTexts'

type DriverViewHeaderProps = {
  driver: uui.domain.client.rm.ExtendedDriver
}

export function DriverViewHeader(props: DriverViewHeaderProps) {
  const { actions } = useTexts()
  const {
    driver: {
      driver: { name, id },
    },
  } = props

  const { setEditing } = useEditingStateWithCtx('driver')
  const { show: showDeleteModal, Modal: DeleteDriverModal } = useDeleteDriverModal()
  const { show: showChangePasswordModal, Modal: ChangePasswordModal } = useChangePasswordModal()

  const onClose = useCallback(() => {
    resetCrudSelection('drivers')
  }, [])

  const { preventEditing, title } = useReadOnlyTooltipData()

  const onEdit = useCallback(() => setEditing([id]), [setEditing, id])

  return (
    <preview.Header title={name} testId="driver-view-header" onClose={onClose}>
      <preview.ActionBar>
        <preview.ActionBarItem
          icon={<Edit />}
          onClick={onEdit}
          label={actions.edit}
          tooltip={preventEditing ? title : undefined}
          disableWhenReadOnly
          testId="edit-button"
          data-trackid="driver-edit-button"
        />
        <preview.ActionBarItem
          icon={<Password />}
          onClick={showChangePasswordModal}
          label={actions.changePassword}
          tooltip={preventEditing ? title : undefined}
          disableWhenReadOnly
          testId="change-password-button"
          data-trackid="driver-change-password-button"
        />
        <preview.ActionBarItem
          icon={<Delete />}
          onClick={showDeleteModal}
          label={actions.delete(1)}
          tooltip={preventEditing ? title : undefined}
          disableWhenReadOnly
          testId="delete-button"
          data-trackid="driver-delete-button"
        />
      </preview.ActionBar>
      <DeleteDriverModal driverIds={[id]} />
      <ChangePasswordModal driverId={id} />
    </preview.Header>
  )
}
